<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="d-flex flex-column gap-3">
    <!-- Tipo -->
    <lib-donation-type-toggle
  [plans]="plans"
  [disabledPlanIds]="disabledPlanIds"
  formControlName="donationType">
</lib-donation-type-toggle>
    <div class="text-danger small" *ngIf="form.get('donationType')?.touched">
      {{ donationTypeError }}
    </div>

    <!-- Monto -->
    <div class="input-group">
      <span class="input-group-text">$</span>
      <input type="number" class="form-control" formControlName="unitAmount" />
      <span class="input-group-text">{{ form.get('currency')?.value || 'USD' }}</span>
    </div>
    <div class="text-danger small" *ngIf="form.get('unitAmount')?.invalid && form.get('unitAmount')?.touched">
      {{ 'CAMPAIGN.AmountIsRequired' | translate }} (min $5)
    </div>

    <button type="submit" class="btn btn-primary col-12" [disabled]="form.invalid">
      {{ 'CAMPAIGN.Donate' | translate }}
    </button>
  </div>
</form>
